
webpack.register(
    'modules/merchandise-unit-card/merchandise-unit-card',
    function() {
        return import('modules/merchandise-unit-card/merchandise-unit-card');
    },
    true
);